import { Exception } from './Exception';
export class CartMissingResponseException extends Exception {
  constructor(stack) {
    super('Missing response for Cart Request', stack);
    this.name = 'CartMissingResponseException';
  }
}
